import React, { useRef, useState, useEffect } from 'react'
import { string, number, arrayOf, element } from 'prop-types'
import classNames from 'classnames'

import Icon from 'components/uiElements/Icon'

require('./QuickAccessRow.scss')

const QuickAccessRow = ({ header, description, length, children }) => {
    const [step, setStep] = useState(0)
    const ref = useRef(null)

    const getStepWidth = () => ref.current.clientWidth / 3

    useEffect(() => {
        if (ref.current) {
            ref.current.scrollLeft = getStepWidth() * step
        }
    })

    const canScroll = () => ({
        canScrollLeft: step > 0,
        canScrollRight: length > step + 3,
    })

    const scroll = (forward) => {
        const cnScrl = canScroll()
        if (ref.current && ((!forward && cnScrl.canScrollLeft) || (forward && cnScrl.canScrollRight))) {
            setStep(step + (forward ? 1 : -1))
        }
    }

    return (
        <section className="QuickAccessRow">
            <div className="sectionHeader">
                <h3>{header}</h3>
                <div className="controlsContainer">
                    <div className={classNames('arrows', canScroll())}>
                        <button
                            className="left"
                            onClick={() => {
                                scroll(false)
                            }}
                        >
                            <Icon code="chevron_left" svg />
                        </button>
                        <button
                            className="right"
                            onClick={() => {
                                scroll(true)
                            }}
                        >
                            <Icon code="chevron_right" svg />
                        </button>
                    </div>
                </div>
            </div>
            <p>{description}</p>
            {length ? (
                <div className="itemsContainer" ref={ref}>
                    <div className="items">{children}</div>
                </div>
            ) : (
                <div className="noItemsContainer">{children}</div>
            )}
        </section>
    )
}

QuickAccessRow.defaultProps = {
    length: 0,
    children: null,
}

QuickAccessRow.propTypes = {
    header: string.isRequired,
    description: string.isRequired,
    length: number,
    children: arrayOf(element),
}

export default QuickAccessRow
